module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lesson-page"
  }, [_c('LessonHeader', {
    staticClass: "LesonTop",
    style: (_vm.safeTopVar),
    attrs: {
      "currentData": _vm.data
    }
  }), _vm._v(" "), (!_vm.data) ? _c('div', {
    staticClass: "loader"
  }, [_vm._v("\n    " + _vm._s(_vm.$t("lesson.lesson-page.loading")) + "\n    "), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "justify-content": "center",
      "margin": "8px"
    }
  }, [_c('SlinkyVue')], 1)]) : _vm._e(), _vm._v(" "), (_vm.data) ? _c('div', {
    staticClass: "centered"
  }, [_c('div', {
    staticClass: "lesson-player"
  }, [(_vm.data.text) ? _c('div', {
    staticStyle: {
      "padding-bottom": "0.5em"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.data.text) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.lessonAudio) ? _c('div', [_c('AudioPlayerLesson', {
    attrs: {
      "audioSrc": _vm.lessonAudio,
      "height": 25,
      "autoPlay": true
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.lessonImage) ? _c('div', [_c('div', [_c('img', {
    attrs: {
      "src": _vm.lessonImage
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.data.video) ? _c('div', [_c('div', [_c('VideoPlayer', {
    attrs: {
      "vidSrc": _vm.makeLinkEmbaddable(_vm.data.video)
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "75px",
      "width": "100%"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "actions-wrapper"
  }, [_c('button', {
    staticClass: "lesson-approve",
    style: (_vm.safeBottomVar),
    on: {
      "click": _vm.finishLesson
    }
  }, [_vm._v("\n      " + _vm._s(_vm.submitting ?
    _vm.$t("lesson.lesson-page.loading2") :
    _vm.$t("lesson.lesson-page.continue")) + "\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1214da69","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lesson/lesson-page.vue
// module id = 469
// module chunks = 1 8